export default __webpack_public_path__ + "84340151dcd588b3a5664a5cfbf136b2.png";